<template>
  <page-listado>
    <page-header title="Unidades de Negocio">
      <b-button variant="primary" size="sm" to="/unidadesNegocio/crear">
        <v-icon name="plus" width="16" />
        Crear unidad de negocio
      </b-button>
      <busqueda-rapida />
    </page-header>
    <tabla :unidades-negocio="unidadesNegocio" @eliminar="eliminar" />
  </page-listado>
</template>

<script>
import * as unidadNegocioApi from "@/services/unidadesNegocio";
import Tabla from "./TablaUnidadesNegocio";

export default {
  components: { Tabla },
  data() {
    return {
      unidadesNegocio: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.listar();
  },
  methods: {
    async listar() {
      this.unidadesNegocio = await unidadNegocioApi.listar(this.$route.query);
    },
    async eliminar(id) {
      await unidadNegocioApi.eliminar(id);
      this.listar();
    },
  },
};
</script>
